import Image from 'next/image'

import Box from '@ilg-totallymoney/ui/components/Box'
import Card from '@ilg-totallymoney/ui/components/Card'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import { ActiveCreditCard } from '@appTypes/EligibilityApi.interface'

import phoneAlert from '@images/info.png'

interface HighlightHeroIneligibleProps {
    item: ActiveCreditCard | null
    totalCreditCards: number
}

const HighlightHeroIneligible = ({
    item,
    totalCreditCards,
}: HighlightHeroIneligibleProps) => {
    const cardText = totalCreditCards === 1 ? 'card' : 'cards'

    return (
        <Card
            py={['space30', 'space30', 'space40']}
            px={['space30', 'space30', 'space50']}
        >
            <Flex>
                <Box mr={['space20', 'space30']}>
                    <Image
                        src={phoneAlert}
                        alt="phone with exclamation mark on screen"
                        width={64}
                    />
                </Box>

                <Stack space="space10" justifyContent="center">
                    <Heading variant="40">
                        We’re sorry - you’re not eligible for this credit card
                    </Heading>

                    <Text variant="100" color="light">
                        {totalCreditCards > 0 ? (
                            <>
                                But we’ve found{' '}
                                <strong>
                                    {totalCreditCards} other {cardText}
                                </strong>{' '}
                                you might be eligible for
                            </>
                        ) : null}
                    </Text>
                </Stack>
            </Flex>
        </Card>
    )
}

export default HighlightHeroIneligible
